<template>
  <div>
    <h2>Colors token</h2>
    <!-- General Colors Loop -->
    <div v-for="(shades, colorName) in colors" :key="colorName">
      <template v-if="colorName !== 'status'">
        <h3>{{ colorName }}</h3>
        <div v-if="typeof shades === 'object'" class="color-shades">
          <div
            v-for="(colorValue, shade) in shades"
            :key="shade"
            :style="{ background: `linear-gradient(90deg, rgba(0, 0, 0, 0.1), ${colorValue}) 100%` }"
            class="color-box"
          >
            {{ colorValue }}
          </div>
        </div>
        <div v-else :style="{ background: `linear-gradient(90deg, rgba(0, 0, 0, 0.1), ${shades})` }" class="color-box" >
          {{ colorValue }}
        </div>
      </template>
    </div>

    <!-- Status Colors Loop -->
    <h2 class="m-t-40">Status Colors</h2>
    <div v-for="(statuses, statusName) in colors.status" :key="statusName">
      <h3>{{ statusName }}</h3>
      <div class="color-shades">
        <div v-for="(colorValue, shade) in statuses" :key="shade" :style="{ background: `linear-gradient(90deg, rgba(0, 0, 0, 0.1), ${colorValue})` }" class="color-box">
          {{ colorValue }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      colors: {
        primary: {
          50: 'var(--primary-50-color)',
          100: 'var(--primary-100-color)',
          200: 'var(--primary-200-color)',
          300: 'var(--primary-300-color)',
          400: 'var(--primary-400-color)',
          500: 'var(--primary-500-color)',
          600: 'var(--primary-600-color)',
          700: 'var(--primary-700-color)',
          800: 'var(--primary-800-color)',
          900: 'var(--primary-900-color)'
        },
        secondary: {
          50: 'var(--secondary-50-color)',
          100: 'var(--secondary-100-color)',
          200: 'var(--secondary-200-color)',
          300: 'var(--secondary-300-color)',
          400: 'var(--secondary-400-color)',
          500: 'var(--secondary-500-color)',
          600: 'var(--secondary-600-color)',
          700: 'var(--secondary-700-color)',
          800: 'var(--secondary-800-color)',
          900: 'var(--secondary-900-color)'
        },
        tertiary: {
          50: 'var(--tertiary-50-color)',
          100: 'var(--tertiary-100-color)',
          200: 'var(--tertiary-200-color)',
          300: 'var(--tertiary-300-color)',
          400: 'var(--tertiary-400-color)',
          500: 'var(--tertiary-500-color)',
          600: 'var(--tertiary-600-color)',
          700: 'var(--tertiary-700-color)',
          800: 'var(--tertiary-800-color)',
          900: 'var(--tertiary-900-color)'
        },
        semanticRed: {
          50: 'var(--semanticRed-50-color)',
          100: 'var(--semanticRed-100-color)',
          200: 'var(--semanticRed-200-color)',
          300: 'var(--semanticRed-300-color)',
          400: 'var(--semanticRed-400-color)',
          500: 'var(--semanticRed-500-color)',
          600: 'var(--semanticRed-600-color)',
          700: 'var(--semanticRed-700-color)',
          800: 'var(--semanticRed-800-color)',
          900: 'var(--semanticRed-900-color)'
        },
        semanticYellow: {
          50: 'var(--semanticYellow-50-color)',
          100: 'var(--semanticYellow-100-color)',
          200: 'var(--semanticYellow-200-color)',
          300: 'var(--semanticYellow-300-color)',
          400: 'var(--semanticYellow-400-color)',
          500: 'var(--semanticYellow-500-color)',
          600: 'var(--semanticYellow-600-color)',
          700: 'var(--semanticYellow-700-color)',
          800: 'var(--semanticYellow-800-color)',
          900: 'var(--semanticYellow-900-color)'
        },
        semanticOrange: {
          50: 'var(--semanticOrange-50-color)',
          100: 'var(--semanticOrange-100-color)',
          200: 'var(--semanticOrange-200-color)',
          300: 'var(--semanticOrange-300-color)',
          400: 'var(--semanticOrange-400-color)',
          500: 'var(--semanticOrange-500-color)',
          600: 'var(--semanticOrange-600-color)',
          700: 'var(--semanticOrange-700-color)',
          800: 'var(--semanticOrange-800-color)',
          900: 'var(--semanticOrange-900-color)'
        },
        semanticBlue: {
          50: 'var(--semanticBlue-50-color)',
          100: 'var(--semanticBlue-100-color)',
          200: 'var(--semanticBlue-200-color)',
          300: 'var(--semanticBlue-300-color)',
          400: 'var(--semanticBlue-400-color)',
          500: 'var(--semanticBlue-500-color)',
          600: 'var(--semanticBlue-600-color)',
          700: 'var(--semanticBlue-700-color)',
          800: 'var(--semanticBlue-800-color)',
          900: 'var(--semanticBlue-900-color)'
        },
        semanticBluegreen: {
          50: 'var(--semanticBluegreen-50-color)',
          100: 'var(--semanticBluegreen-100-color)',
          200: 'var(--semanticBluegreen-200-color)',
          300: 'var(--semanticBluegreen-300-color)',
          400: 'var(--semanticBluegreen-400-color)',
          500: 'var(--semanticBluegreen-500-color)',
          600: 'var(--semanticBluegreen-600-color)',
          700: 'var(--semanticBluegreen-700-color)',
          800: 'var(--semanticBluegreen-800-color)',
          900: 'var(--semanticBluegreen-900-color)'
        },
        semanticGreen: {
          50: 'var(--semanticGreen-50-color)',
          100: 'var(--semanticGreen-100-color)',
          200: 'var(--semanticGreen-200-color)',
          300: 'var(--semanticGreen-300-color)',
          400: 'var(--semanticGreen-400-color)',
          500: 'var(--semanticGreen-500-color)',
          600: 'var(--semanticGreen-600-color)',
          700: 'var(--semanticGreen-700-color)',
          800: 'var(--semanticGreen-800-color)',
          900: 'var(--semanticGreen-900-color)'
        },
        semanticViolet: {
          50: 'var(--semanticViolet-50-color)',
          100: 'var(--semanticViolet-100-color)',
          200: 'var(--semanticViolet-200-color)',
          300: 'var(--semanticViolet-300-color)',
          400: 'var(--semanticViolet-400-color)',
          500: 'var(--semanticViolet-500-color)',
          600: 'var(--semanticViolet-600-color)',
          700: 'var(--semanticViolet-700-color)',
          800: 'var(--semanticViolet-800-color)',
          900: 'var(--semanticViolet-900-color)'
        },
        semanticPink: {
          50: 'var(--semanticPink-50-color)',
          100: 'var(--semanticPink-100-color)',
          200: 'var(--semanticPink-200-color)',
          300: 'var(--semanticPink-300-color)',
          400: 'var(--semanticPink-400-color)',
          500: 'var(--semanticPink-500-color)',
          600: 'var(--semanticPink-600-color)',
          700: 'var(--semanticPink-700-color)',
          800: 'var(--semanticPink-800-color)',
          900: 'var(--semanticPink-900-color)'
        },
        coolGrey: {
          25: 'var(--coolGrey-25-color)',
          50: 'var(--coolGrey-50-color)',
          100: 'var(--coolGrey-100-color)',
          200: 'var(--coolGrey-200-color)',
          300: 'var(--coolGrey-300-color)',
          400: 'var(--coolGrey-400-color)',
          500: 'var(--coolGrey-500-color)',
          600: 'var(--coolGrey-600-color)',
          700: 'var(--coolGrey-700-color)',
          800: 'var(--coolGrey-800-color)',
          900: 'var(--coolGrey-900-color)'
        },
        white: '#fff',
        black: '#000',
        status: {
          positive: {
            50: 'var(--semanticGreen-50-color)',
            100: 'var(--semanticGreen-100-color)',
            200: 'var(--semanticGreen-200-color)',
            300: 'var(--semanticGreen-300-color)',
            400: 'var(--semanticGreen-400-color)',
            500: 'var(--semanticGreen-500-color)',
            600: 'var(--semanticGreen-600-color)',
            700: 'var(--semanticGreen-700-color)',
            800: 'var(--semanticGreen-800-color)',
            900: 'var(--semanticGreen-900-color)'
          },
          negative: {
            50: 'var(--semanticRed-50-color)',
            100: 'var(--semanticRed-100-color)',
            200: 'var(--semanticRed-200-color)',
            300: 'var(--semanticRed-300-color)',
            400: 'var(--semanticRed-400-color)',
            500: 'var(--semanticRed-500-color)',
            600: 'var(--semanticRed-600-color)',
            700: 'var(--semanticRed-700-color)',
            800: 'var(--semanticRed-800-color)',
            900: 'var(--semanticRed-900-color)'
          },
          critical: {
            50: 'var(--semanticRed-50-color)',
            100: 'var(--semanticRed-100-color)',
            200: 'var(--semanticRed-200-color)',
            300: 'var(--semanticRed-300-color)',
            400: 'var(--semanticRed-400-color)',
            500: 'var(--semanticRed-500-color)',
            600: 'var(--semanticRed-600-color)',
            700: 'var(--semanticRed-700-color)',
            800: 'var(--semanticRed-800-color)',
            900: 'var(--semanticRed-900-color)'
          },
          inProgress: {
            50: 'var(--semanticYellow-50-color)',
            100: 'var(--semanticYellow-100-color)',
            200: 'var(--semanticYellow-200-color)',
            300: 'var(--semanticYellow-300-color)',
            400: 'var(--semanticYellow-400-color)',
            500: 'var(--semanticYellow-500-color)',
            600: 'var(--semanticYellow-600-color)',
            700: 'var(--semanticYellow-700-color)',
            800: 'var(--semanticYellow-800-color)',
            900: 'var(--semanticYellow-900-color)'
          },
          verifying: {
            50: 'var(--semanticOrange-50-color)',
            100: 'var(--semanticOrange-100-color)',
            200: 'var(--semanticOrange-200-color)',
            300: 'var(--semanticOrange-300-color)',
            400: 'var(--semanticOrange-400-color)',
            500: 'var(--semanticOrange-500-color)',
            600: 'var(--semanticOrange-600-color)',
            700: 'var(--semanticOrange-700-color)',
            800: 'var(--semanticOrange-800-color)',
            900: 'var(--semanticOrange-900-color)'
          },
          warning: {
            50: 'var(--semanticOrange-50-color)',
            100: 'var(--semanticOrange-100-color)',
            200: 'var(--semanticOrange-200-color)',
            300: 'var(--semanticOrange-300-color)',
            400: 'var(--semanticOrange-400-color)',
            500: 'var(--semanticOrange-500-color)',
            600: 'var(--semanticOrange-600-color)',
            700: 'var(--semanticOrange-700-color)',
            800: 'var(--semanticOrange-800-color)',
            900: 'var(--semanticOrange-900-color)'
          },
          informing: {
            50: 'var(--semanticBlue-50-color)',
            100: 'var(--semanticBlue-100-color)',
            200: 'var(--semanticBlue-200-color)',
            300: 'var(--semanticBlue-300-color)',
            400: 'var(--semanticBlue-400-color)',
            500: 'var(--semanticBlue-500-color)',
            600: 'var(--semanticBlue-600-color)',
            700: 'var(--semanticBlue-700-color)',
            800: 'var(--semanticBlue-800-color)',
            900: 'var(--semanticBlue-900-color)'
          },
          concerning: {
            50: 'var(--semanticViolet-50-color)',
            100: 'var(--semanticViolet-100-color)',
            200: 'var(--semanticViolet-200-color)',
            300: 'var(--semanticViolet-300-color)',
            400: 'var(--semanticViolet-400-color)',
            500: 'var(--semanticViolet-500-color)',
            600: 'var(--semanticViolet-600-color)',
            700: 'var(--semanticViolet-700-color)',
            800: 'var(--semanticViolet-800-color)',
            900: 'var(--semanticViolet-900-color)'
          }
        }
      }
    }
  },
  methods: {
    generateBackgroundStyle (shades) {
      if (typeof shades === 'string') {
        return { backgroundColor: shades }
      } else if (typeof shades === 'object') {
        // You can return the background for the first shade (for demo purposes).
        const firstShade = Object.values(shades)[0]
        return { backgroundColor: firstShade }
      }
      return {}
    }
  }
}
</script>

<style scoped>
.color-display {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 20px;
}

.color-shades {
  display: flex;
  gap: 12px;
  flex-direction: column;
}

.color-box {
  padding: 48px;
  color: #fff;
  border-radius: 24px;
}

.color-name {
  font-weight: bold;
  margin-bottom: 5px;
}

.color-var {
  font-size: 0.8rem;
  color: #555;
}
</style>
